export default function() {
    let $viewportMeta = $('meta[name="viewport"]'),
        viewportMetaContent = $viewportMeta.attr('content'),
        zoomEnableTimeout = function () {};

    // prevent mobile zoom in
    $('input, select, textarea').bind('touchstart focus blur', function (event) {
        if (event.type === 'blur') {
            zoomEnableTimeout = setTimeout(function () {
                $viewportMeta.attr('content', viewportMetaContent);
            }, 100);
        } else {
            clearTimeout(zoomEnableTimeout);
            $viewportMeta.attr('content', viewportMetaContent + ',maximum-scale=1');
        }
    });
}



// WEBPACK FOOTER //
// ./node_modules/@spinnwerk/form-helper/prevent-mobile-zoom.js